<script>
import moment from "moment";
export default {
  name: 'StepItem.vue',
  props: ["percentage", "timeLinePercentage", "visible", "step", "vertical"],
  data() {
    return {

    };
  },
  computed: {
    stepDate(){
      return moment(this.step, "DD-MM-YYYY");
    },
    stepStyle() {
      return !this.vertical
          ? { left: this.percentage < 100 ? `${this.percentage}%` : `calc((${this.percentage}% - 10px)` }
          : { top: `${this.percentage > 100 ? 100 : this.percentage}%` };
    }
  },
  methods: {

  },
  mounted() {

  }
};
</script>

<template>
  <div class="step-item d-flex  position-absolute"
       :style="stepStyle" :class="{'flex-row-reverse align-items-center': vertical, 'flex-column justify-content-center align-items-center': !vertical}">
    <div class="step-details text-white mb-3" :class="{'text-center': !vertical, 'd-flex align-items-center': vertical}">
      <span class="step-details-title text-nowrap" :class="{'invisible': step.title === '', 'mr-3': vertical}" v-html="step.title"></span><br>
      <span class="step-details-date text-nowrap" :class="{'invisible': step.title === ''}">{{step.display_date}}</span>
    </div>
    <div class="step-item-mark"
         :class="{'achieved': timeLinePercentage >= percentage, 'invisible': (this.visible !== undefined && !this.visible)}"
    >
    </div>
  </div>

</template>

<style scoped>

.step-item{
  bottom: -4px;
  min-height: 34px;
}
.step-item-mark{
  height: 16px;
  aspect-ratio: 1;
  background: var(--forground-bg-color);
  border-radius: 50%;
  box-shadow: inset 0 0 5px rgba(0,0,0, 0.4);
}
.step-item-mark.achieved{
  box-shadow: unset;
  background: var(--main-color) !important;
}
.step-details-title{
  font-family: "sqwaredregular";
  font-size: 11pt;
}
.step-details-date{
  font-family: "sqwaredthin";
  color:#E2E2E2;
  font-size: 10pt;
}

@media (max-width: 575.98px) {
  .step-item {
    margin-left: -4px;
    bottom: auto;
  }

  .step-details {
    margin-bottom: 0 !important;
    margin-left: 12px;
    text-align: left;
    align-items: flex-start;
  }
}
</style>
